module.exports = __webpack_public_path__ + "static/media/interview.f97c660c.png";